import React from 'react';
import { Link } from 'react-router-dom';
import { Exercise } from '../../data/exercises';
import '../TestCard/TestCard.css'; // Reuse TestCard styles for consistency

interface ExerciseCardProps {
    exercise: Exercise;
}

const ExerciseCard: React.FC<ExerciseCardProps> = ({ exercise }) => {
    return (
        <div className="test-card">
            <div className="test-card-icon-container">
                {exercise.imageUrl && (
                    <img
                        src={exercise.imageUrl}
                        alt={exercise.title}
                        className="test-card-image"
                    />
                )}
            </div>
            <div className="test-card-content">
                <h3 className="test-card-title">{exercise.title}</h3>
                <p className="test-card-description">{exercise.shortDescription}</p>
                <div className="test-card-footer">
                    <span className="test-card-duration">
                        ⏱ {exercise.duration}
                    </span>
                    <Link to={`/materials/exercise/${exercise.id}`} className="test-card-button">
                        Начать упражнение
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ExerciseCard;
